import { SearchableOption } from '../../../types';
import { transformToCompetentNLBase } from '../CompetentNL/CompetentNLTransformers';
import { transformToSkillBase } from '../Skills/SkillsTransformers';
import {
    Occupation,
    OccupationBase,
    OccupationBaseResource,
    OccupationResource,
} from './Occupations';

export const transformToOccupationBase = (resource: OccupationBaseResource): OccupationBase => {
    const base = transformToCompetentNLBase(resource);

    return {
        ...base,
        altLabels: resource.altLabels,
    };
};

export const transformToOccupation = (resource: OccupationResource): Occupation => {
    const occupationBase = transformToOccupationBase(resource);

    const essentialSkills = resource.essentialSkills
        ? resource.essentialSkills.map(transformToSkillBase)
        : [];

    const importantSkills = resource.importantSkills
        ? resource.importantSkills.map(transformToSkillBase)
        : [];

    const extraSkills = resource.extraSkills
        ? resource.extraSkills.map(transformToSkillBase)
        : [];

    return {
        ...occupationBase,
        scheme: resource.scheme,
        conceptOf: resource.conceptOf,
        essentialSkills,
        importantSkills,
        extraSkills,
    };
};

export const transformOccupationToSearchableOption = (occupation: Occupation): SearchableOption => {
    const secondaryLabel = occupation.altLabels.join(', ');

    return {
        value: occupation.id,
        label: occupation.label,
        secondaryLabel,
    };
};
